import FormHelperText from '@mui/material/FormHelperText';
import { styled } from '../../theme';
export type { FormHelperTextProps } from '@mui/material/FormHelperText';

const FormHelperTextStyled = styled(FormHelperText)({
    marginLeft: 0,
});

export default FormHelperTextStyled;
